import { type PortfolioStatementKey } from "./portfolioUiTypes"

export const ESSAY_CHAR_LIMIT = 600

// Reserved selection/timeline IDs for the two Sustained Investigation essays.
// They live in the same `activeProjectId` selection slot and `projectId`
// timeline field as real projects, so they must never collide with a real
// project id (real ids are `project-<ts>-<rand>` or the unassigned sentinel).
export const ESSAY_SELECTION_IDS: Record<PortfolioStatementKey, string> = {
  sustainedInquiryQuestion: "essay-sustained-inquiry-question",
  sustainedPracticeEvidence: "essay-sustained-practice-evidence",
}

export const ESSAY_LABELS: Record<PortfolioStatementKey, string> = {
  sustainedInquiryQuestion: "Inquiry Question",
  sustainedPracticeEvidence: "Practice, Experimentation, Revision",
}

export const ESSAY_PROMPTS: Record<PortfolioStatementKey, string> = {
  sustainedInquiryQuestion:
    "Identify the questions or inquiry that guided this sustained investigation.",
  sustainedPracticeEvidence:
    "Describe ways this sustained investigation developed through practice, experimentation, and revision.",
}

export const getEssayKeyFromSelectionId = (
  id: string | null | undefined
): PortfolioStatementKey | undefined => {
  if (!id) return undefined
  const match = (
    Object.entries(ESSAY_SELECTION_IDS) as Array<
      [PortfolioStatementKey, string]
    >
  ).find(([, selectionId]) => selectionId === id)
  return match?.[0]
}
